import "./css/styles.css";
import "./css/new-styles.css";

import NavBar from "./components/NavBar";
import Intro from "./components/Intro";
import About from "./components/about";
import Experience from "./components/experience";
import Education from "./components/education";
import Skills from "./components/skills";
import Projects from "./components/projects";
import Footer from "./components/footer";
function App() {
  return (
    <div>
      <NavBar />
      <div className="center w-80">
        <Intro />
        <About />
        <Experience />
        <Education/>
        <Skills />
        <Projects />
        <div className="flex flex-column justify-center items-center">
          <div className="f1-l f2 mb4-l mb3">
            <b>Lets Connect :)</b>
          </div>
          <a
            href="mailto:baljinder9219@gmail.com"
            className="mt3 ba button-transition pointer primary glassmorphic-2 pv2 ph4 no-underline br3"
          >
            Reach me
          </a>
        </div>
      </div>
      <Footer/>
    </div>
  );
}

export default App;
